import { atom } from "jotai";

export const cumpleaniosAtom = atom([]);
export const totalCumpleaniosAtom = atom(0);
export const paginaAtom = atom(0);